// extracted by mini-css-extract-plugin
module.exports = {"separator":"Separator_separator__1P5pw"};